import { Injectable } from '@angular/core';

/**
 * Holds the pseudonymous user id that goes out with every server log.
 *
 * The app sets it whenever the auth state changes (login, logout, anonymous sign-up, app start);
 * NgxLoggerCustomServerService reads it when it builds the request body. Nothing is persisted -
 * a reload starts empty until the app sets the id again.
 */
@Injectable({
    providedIn: 'root'
})
export class LogUserContextService {

    private currentUserId: string | null = null;

    /** `null` (or an empty string) clears the id, so reports go out without a user again. */
    setUserId(userId: string | null): void {
        this.currentUserId = userId ? userId : null;
    }

    get userId(): string | null {
        return this.currentUserId;
    }
}
